

import { Options, Vue } from "vue-class-component";
import { useStore } from "vuex";
import { key } from "@/store";
import { Loader } from "@googlemaps/js-api-loader";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faSearch, faCaretDown } from "@fortawesome/free-solid-svg-icons";

library.add( faSearch, faCaretDown );

@Options( {
  props      : {
    search_page     : Boolean,
    tarif           : Boolean,
    buttonText      : String,
    placeholderText : String
  },
  components : { FontAwesomeIcon }
} )
export default class SearchBar extends Vue
{
  store     = useStore( key );
  geocoding = false;
  is_loaded = false;
  search    = "";

  input : any;
  loader : any;
  google : any;
  service : any;
  autocomplete : any;

  props = Object.assign( {}, ... Object.entries( this.$props ).map( ( [key, value] ) => ({ [key] : value }) ) );

  load_libs()
  {
    if( this.is_loaded )
      return;

    this.is_loaded = true;

    if( process.env.NODE_ENV === "development" )
      this.loader = new Loader( { apiKey : "AIzaSyC8CpdQRp0iPsVQ8kxk96KQCSmkzzY5GwA", libraries : ["places"] } );
    else
      this.loader = new Loader( { apiKey : "AIzaSyDVtHU-GAEn-Q08xcJXH5Fv0yh6QV1el9c", libraries : ["places"] } );

    this.loader.load().then( ( google : any ) => {
      this.google = google;
      this.input  = document.getElementById( "search-box-places" ) as HTMLInputElement;

      // Service for later
      this.service = new this.google.maps.places.AutocompleteService();

      this.autocomplete = new google.maps.places.Autocomplete( this.input );
      this.autocomplete.setComponentRestrictions( { "country" : ["fr"] } );
      this.autocomplete.addListener( "place_changed", this.do_search );

      // Fix for the search by button click
      document.querySelector( "#search-submit" )?.addEventListener( "click", this.do_search );
    } );
  }

  do_search()
  {
    // console.log( this.autocomplete.getPlace() );

    // Don't search if already geocoding
    if( this.search === "" )
      return false;

    // Simulate down arrow press if nothing selected
    if( typeof this.autocomplete.getPlace() === "undefined" || typeof this.autocomplete.getPlace().place_id === "undefined" )
    {
      // console.log( "Getting predictions ..." );
      this.service.getPlacePredictions( {
        input                 : this.search,
        componentRestrictions : { "country" : ["fr"] }
      }, this.predict );
      return false;
    } else
    {
      // console.log( "Getting exact selection ..." );
      this.geocode( this.autocomplete.getPlace().place_id );
      return false;
    }
  }

  predict( predictions : any, status : any )
  {
    if( status != this.google.maps.places.PlacesServiceStatus.OK || !predictions )
    {
      // TODO : Real modal
      alert( "Impossible de trouver cette ville, veuillez réessayer\n(Error : " + status + ")" );
      return;
    }

    this.input.value = predictions[0].description;
    this.geocode( predictions[0].place_id );
  }

  geocode( place_id : any )
  {
    this.geocoding           = true;
    this.store.state.loading = true;

    fetch( this.store.state.apiVue + "places/" + place_id + "/" + (this.props.tarif ? 1 : 0), {
      method : "GET",
      cache  : "no-cache"
    } ).then( ( res ) => {
      return res.json();
    } ).then( ( res ) => {
      if( typeof res.data.url !== "undefined" && res.data.url !== "" && res.data.url !== null )
      {
        document.location.assign( res.data.url.replace( "https://www.location-gardemeuble.fr/", process.env.BASE_URL ) );
      } else
      {
        alert( "Impossible de trouver cette ville !" );
        this.geocoding           = false;
        this.store.state.loading = false;
      }
    } ).catch( error => {
      console.error( error );
      this.geocoding = false;
    } );
  }
}
